export const getEnumValues = (enumeration: object) => Object.values(enumeration).filter((item) => isNaN(Number(item)));
